define('contrato-controller',['contrato-resource'], function() {

    var app = angular.module('contrato.controller', [
        'contrato.resource'
    ]);

    app.controller('ContratoControllerIndex', ['$scope', '$rootScope', 'Contrato', function($scope, $rootScope, Contrato) {
        $scope.contratos = contratos;
        $scope.createSolicitacaoModal = false;
        $scope.con_codigo = null;
        $scope.con_data_imovel_desocupacao = new Date(moment().format("YYYY-MM-DD"));
        $scope.con_motivo_imovel_desocupacao = "";

        $scope.setModel = function(model, value){
            $scope[model] = value;
        };

        $scope.solicitarDesocupacao = function(codigo){
            $scope.solicitacaoEnviada = false;
            //solicita desocupacao
            $scope.formAtual = 'desocupacao';
            $scope.formName = 'Desocupação do imóvel';
            $scope.createSolicitacaoModal = true;
            $scope.con_codigo = codigo;
        }

        $scope.getContratos = function(){
            Contrato.getContratos({}).then(function (res) {
                console.log('GET contratos');
                console.log(res);
                $scope.contratos = res.data;
            }).catch(function (err) {
                console.error(err);
            });
        };

        $scope.getContratos();

        $scope.enviarSolicitacao = function(){
            var payload = {
                con_data_imovel_desocupacao: $scope.con_data_imovel_desocupacao,
                con_motivo_imovel_desocupacao: $scope.con_motivo_imovel_desocupacao,
                con_codigo: $scope.con_codigo
            };
            Contrato.saveSolicitacao(payload).then(function (response) {
                $scope.solicitacaoEnviada = true;
                $scope.getContratos();
            }).catch(function (err) {
                console.error(err);
            });
        };
    }]);
});

